import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { api } from "@api/api";
import { ApiError } from "@shared/types";
import { PartnerTier } from "@modules/partners/types";
import { TierFormValues } from "@modules/partners/validations";

import { listTiersQueryKey } from "../createTier/mutation";

export function useEditTierMutation() {
  const translate = useTranslate();
  const { open } = useNotification();
  const queryClient = useQueryClient();

  return useMutation<PartnerTier, ApiError, { id: number; values: TierFormValues }>({
    mutationFn: async ({ id, values }) => {
      const { data } = await api.patch<PartnerTier>(`/v1/partner_tier_admin/${id}/`, values);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: listTiersQueryKey, refetchType: "all" });
      open?.({ type: "success", message: translate("v1/partner_tier_admin.success.edit") });
    },
    onError: (error: ApiError) => {
      open?.({ type: "error", message: error.response.data.error });
    },
  });
}
